import React from 'react';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import { BiSearch } from 'react-icons/bi';
import styled from 'styled-components';

import Container from '../../components/UI/Container';
import Grid from '../../components/UI/Grid';
import Button from '../../components/UI/Button';
import Pagination from '../../components/UI/Pagination';
import Table from '../../components/UI/Table';
import TextField from '../../components/UI/TextField';
import Select from '../../components/UI/Select';
import { Link } from 'react-router-dom';
import { axiosCustom } from '../../function/common';

export default function ShopList() {
    // ip 체크 여부
    const [ipCheck, setIpCheck] = React.useState(false);
    // 페이지당 노출 수
    const [viewCount, setViewCount] = React.useState(10);
    // 현재 페이지
    const [nowPage, setNowPage] = React.useState(1);
    //검색 솔루션 타입
    const [searchSolType, setSearchSolType] = React.useState('ALL');
    //검색 타입
    const [searchType, setSearchType] = React.useState('shopName');
    //검색 키워드
    const [searchValue, setSearchValue] = React.useState('');
    // 작업 총 수
    const [max, setMax] = React.useState(0);
    // 작업 데이터
    const [jobData, setJobData] = React.useState([]);

    const fileEl = React.useRef<any>(null);

    React.useEffect(() => {
        async function ip() {
            try {
                await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/ip-check`);
                setIpCheck(true);
                getJobData();
            } catch (error: any) {
                const confirm = await Swal.fire({
                    title: '실패',
                    html: error.message,
                    icon: 'error',
                });
                if (confirm.isConfirmed) {
                    window.location.href = 'https://plto.com';
                }
            }
        }
        ip();
    }, [nowPage]);

    // 솔루션 타입 셀렉트 이벤트
    const solTypeEvent = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSearchSolType(e.target.value);
    };

    // 검색 타입 셀렉트 이벤트
    const searchTypeEvent = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSearchType(e.target.value);
    };

    // 검색 값 이벤트
    const textFieldOnChange = (e: any) => {
        setSearchValue(e.target.value);
    };

    function onSubmit(e: any) {
        e.preventDefault();
        getJobData();
        // 검색 후 1페이지로 초기화
        setNowPage(1);
    }

    // 검색 이벤트
    async function getJobData() {
        Swal.fire({
            title: '잠시만 기다려 주세요.',
            html: '작업 조회중 ...', // add html attribute if you want or remove
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            },
        });

        try {
            const { data: result } = await axios.get(
                //`${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/get-shop-list`,
                `${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/get-shop-list`,
                {
                    params: {
                        searchType: searchType,
                        searchValue: searchValue,
                        viewCount,
                        nowPage,
                    },
                },
            );
            if (result.totalCount === 0) {
                Swal.fire({
                    title: '실패',
                    html: `정보가 조회되지 않습니다.`,
                    icon: 'error',
                });
            } else {
                // 작업 데이터 설정
                setJobData(result.result);
                // 최대 페이지 설정
                setMax(Math.ceil(result.totalCount / viewCount));

                Swal.close();
            }
        } catch (error: any) {
            Swal.fire({
                title: '실패',
                html: `${error.message}`,
                icon: 'error',
            });
        }
    }

    // 엑셀 업로드 이벤트
    async function excelUpload(e: any) {
        try {
            Swal.fire({
                title: '엑셀 업로드 진행중...',
                html: '잠시만 기다려주세요.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const formData = new FormData();
            formData.append('file', e.currentTarget.files[0]);
            await axiosCustom.post(
                `${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/support-shop-excel-form-upload`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } },
            );

            Swal.fire({
                title: '성공',
                html: '엑셀 업로드 완료 (등록/수정)',
                icon: 'success',
            });
        } catch (error: any) {
            Swal.fire({
                title: '실패',
                html: `${error.message}`,
                icon: 'error',
            });
        }

        fileEl.current.value = '';
    }

    return (
        <Container>
            <Grid display="flex" alignItems="center" justifyContent="center" bottom={20}>
                <h1>플토 지원 쇼핑몰 현황</h1>
            </Grid>
            <Grid display="flex" alignItems="center" justifyContent="flex-start" bottom={20}>
                <Link
                    to={{
                        pathname: '/admin/shop-list-update',
                    }}
                >
                    <Button>새로 만들기</Button>
                </Link>
                &nbsp;
                <Button
                    onClick={() => {
                        fileEl.current.click();
                    }}
                >
                    엑셀 업로드
                </Button>
                &nbsp;
                <input
                    type="file"
                    name="excel-upload"
                    ref={fileEl}
                    onChange={excelUpload}
                    style={{ display: 'none' }}
                />
                <a href={`${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/support-shop-excel-form`}>
                    <Button>엑셀 다운로드(업로드 양식) </Button>
                </a>
            </Grid>
            <form onSubmit={onSubmit}>
                <Grid display="flex" alignItems="center" justifyContent="flex-end" bottom={20}>
                    <Select variant="outlined" onChange={searchTypeEvent} style={{ fontSize: '0.88rem' }}>
                        <option value="shopName">쇼핑몰이름</option>
                        <option value="shopCode">쇼핑몰코드</option>
                    </Select>
                    &nbsp;
                    <TextField
                        type="text"
                        placeholder="조회 할 내용"
                        defaultValue=""
                        defaultSize="full"
                        onChange={textFieldOnChange}
                    />
                    &nbsp;
                    <Button type="submit">검색</Button>
                </Grid>
            </form>
            <Grid>
                <Table
                    headerItems={[
                        {
                            width: 60,
                            headerName: 'DB',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },
                        {
                            width: 100,
                            headerName: '노출순서',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },
                        {
                            width: 100,
                            headerName: '등록일',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },
                        {
                            width: 100,
                            headerName: '수정일',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },
                        {
                            width: 200,
                            headerName: '쇼핑몰명',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },

                        {
                            width: 150,
                            headerName: '쇼핑몰구분',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },

                        {
                            width: 100,
                            headerName: '지원여부',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },
                        {
                            width: 100,
                            headerName: 'EMP 코드',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },
                        {
                            width: 100,
                            headerName: 'GMP 코드',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },
                        {
                            width: 120,
                            headerName: 'GLOBAL 코드',
                            align: 'center',
                            headerAlign: 'center',
                            editable: true,
                        },
                        {
                            width: 110,
                            headerName: '수정',
                            align: 'center',
                            headerAlign: 'center',
                            renderCell: (params: any) => {
                                return (
                                    <Grid display="flex" justifyContent="center">
                                        <Link
                                            to={{
                                                pathname: '/admin/shop-list-update',
                                                state: {
                                                    empShopCode: params.value.empShopCode,
                                                    gmpShopCode: params.value.gmpShopCode,
                                                    globalShopCode: params.value.globalShopCode,
                                                },
                                            }}
                                        >
                                            <Button variant="outlined">
                                                <BiSearch color="black" size="0.77rem" />
                                            </Button>
                                        </Link>
                                    </Grid>
                                );
                            },
                        },
                    ]}
                    bodyItems={jobData.map((one: any) => [
                        one.id,
                        one.sorting,
                        one.createdAt,
                        one.updatedAt,
                        one.shopName,
                        one.cate,
                        one.support,
                        one.empShopCode,
                        one.gmpShopCode,
                        one.globalShopCode,
                        {
                            empShopCode: one.empShopCode,
                            gmpShopCode: one.gmpShopCode,
                            globalShopCode: one.globalShopCode,
                        },
                    ])}
                />
                <Grid top={30} />
                <Pagination nowPage={nowPage} max={max} size={5} nowPageEvent={setNowPage} />
            </Grid>
        </Container>
    );
}
